import { useContext } from "react";
import { __callbacks } from "Utils/Callbacks/Callback";
import { ConfigContext } from "Utils/Contexts";
import styles from "./ButtonClose.module.scss";


export default function ButtonClose() {

  const configContext = useContext(ConfigContext);
  
  const handleClick = (e) => {
    __callbacks.explorerClose.trigger({ data: "you clicked on close button!" });

  }

  // useEffect(() => {
  //   init();
  // }, []);

  // const init = () => {
  //   window.onExplorerClose = (callback) => {
  //     __callbacks.registerCallback(__id, callback);
  //   }
  // }



  return (
    <div
      className={
        `${styles.container} 
        configContext-buttonClose-backgroundColor 
        `
      } onClick={handleClick}>
      <img src={configContext.buttonClose.icon} alt="" />
    </div>
  )
}
